<div class="container-fluid pt-1">

  <div class="login-box mt-5">

    <div class="card">
      <div class="card-header bg-dark">

        <div class="text-center text-orange"> <i class="nav-icon fa fa-lock mr-1 text-orange" aria-hidden="true"></i><strong>orangeye Login </strong></div>
      </div>
      <div class="card-body login-card-body">

        <div class="text-center">
          <img src="../../../../assets/img/OrangEyeLogo.png"
               alt="/"
               style="height:80px;width:80px" />
        </div>
        <p class="login-box-msg"><strong>Login with your credentials please.</strong></p>
        <!--<form #f="ngForm" (ngSubmit)="login()">-->
        <div class="input-group mb-2">
          <input type="text"
                 name="name"
                 #uname=ngModel
                 [(ngModel)]="userName"
                 class="form-control"
                 required
                 placeholder="Userame" />
          <div class="input-group-append">
            <span class="input-group-text bg-gradient-light"><i class="fas fa-user-tie"></i></span>
          </div>
        </div>

        <div class="input-group mb-2">
          <input type="password"
                 required
                 name="password"
                 class="form-control"
                 #pass=ngModel
                 [(ngModel)]="password"
                 placeholder="Password" (keyup.enter)="login()" />
          <div class="input-group-append">
            <span class="input-group-text bg-gradient-light"><i class="fa fa-key icon"></i></span>
          </div>
        </div>
        <div class="row">
          <div class=" col-12 text-center">
            <!--<button class="btn btn-dark" style="height:fit-content" (click)="login()" pTooltip=" Login ">Login&nbsp;<i class="pi pi-key"></i></button>-->
            <button class="btn btn-dark btn-lg" (click)="login()" [disabled]="signInProgress">
              <span *ngIf="signInProgress"><i class="fa fa-spinner fa-spin"></i> Signing In..</span>
              <span *ngIf="!signInProgress">Sign In</span>
            </button>
            <!--<button class="btn btn-dark" type="submit">Login</button>-->
          </div>

        </div>
        <!--</form>-->

      </div>
      <!--/.login-card-body-->
    </div>

  </div>

</div>

